import type { AiChatbotChunkEntity } from "../../../../services/server-side-events-ai-chatbot/entities/ai-chatbot-chunk.entity";
import { StreamMessageDataSource } from "../../datasources/stream-message/stream-message.datasource";
import type { IStreamMessageDataSource } from "../../datasources/stream-message/stream-message.datasource.interface";
import type { IStreamMessageRepository } from "./stream-message.repository.interface";

export class StreamMessageRepository implements IStreamMessageRepository {
  constructor(private _datasource: IStreamMessageDataSource = new StreamMessageDataSource()) {}

  public listen(eventCallback: (message: AiChatbotChunkEntity) => void, errorCallback: (message: Error) => void): void {
    this._datasource.listen(eventCallback, errorCallback);
  }

  public close(): void {
    this._datasource.close();
  }
}
